import {
  Column,
  Columns,
  IconFilter,
  IconSearch,
  Inline,
  Text,
  TextDropdown,
  TextField,
} from 'braid-design-system';

import { LISTING_SORTS, type ListingSort } from './filterListings';

const SORT_LABELS: Record<ListingSort, string> = {
  alphabetical: 'A-Z',
  datePosted: 'Date posted',
  category: 'Category',
};

const SORT_OPTIONS = LISTING_SORTS.map((value) => ({
  text: SORT_LABELS[value],
  value,
}));

interface DirectoryFiltersProps {
  availableServiceTypes: string[];
  serviceType: string;
  sort: ListingSort;
  search: string;
  onServiceTypeChange: (value: string) => void;
  onSortChange: (value: ListingSort) => void;
  onSearchChange: (value: string) => void;
}

export const DirectoryFilters = ({
  availableServiceTypes,
  serviceType,
  sort,
  search,
  onServiceTypeChange,
  onSortChange,
  onSearchChange,
}: DirectoryFiltersProps) => (
  <Columns space="medium" collapseBelow="tablet" alignY="center">
    <Column>
      <TextField
        icon={<IconSearch />}
        id="filter-search"
        aria-label="Search"
        value={search}
        onChange={(e) => onSearchChange(e.currentTarget.value)}
        placeholder="Search by name, company or description"
      />
    </Column>
    <Column width="content">
      <Inline space="medium" alignY="center">
        {availableServiceTypes.length > 0 ? (
          <Text>
            Show{' '}
            <TextDropdown
              id="filter-service-type"
              label="Service type"
              value={serviceType}
              onChange={onServiceTypeChange}
              options={['All', ...availableServiceTypes]}
            />
          </Text>
        ) : null}
        <Text>
          <IconFilter />{' '}
          <TextDropdown
            id="filter-sort"
            label="Arrange by"
            value={sort}
            onChange={onSortChange}
            options={SORT_OPTIONS}
          />
        </Text>
      </Inline>
    </Column>
  </Columns>
);
